module.exports = __webpack_public_path__ + "static/ccs-b177259b30a2ffa8181b5ea67a8b918c.svg";